var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptionItalic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5px",
    height: "12px",
    viewBox: "0 0 5 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Aktualnosci",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aktualnosci---artykul---1-edytor",
    transform: "translate(-346.000000, -776.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dodaj-artykul",
    transform: "translate(233.000000, 369.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(37.000000, 389.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(46.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "I",
    points: "31.984375 13 34.4140625 1.578125 33.1015625 1.578125 30.671875 13"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionItalic);
export default __webpack_public_path__ + "static/media/optionItalic.9c10fa6773f3fcec71681f0130126d02.svg";
export { ForwardRef as ReactComponent };